import * as React from "react";
import type { SVGProps } from "react";
const SvgMaximise01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.648 2.4h6.951m0 0v6.952m0-6.952-8.11 8.11M9.352 21.6H2.401m0 0v-6.952m0 6.952 8.11-8.11"
    />
  </svg>
);
export default SvgMaximise01;
